import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { CartAttributeKeys } from '@/models';

export const updateCartAttributeByName = createAppAsyncThunk(
  'checkout/updateCartAttributeByName',
  async ({ attributeName, newValue }: Payload, { rejectWithValue, getState, signal, extra: { checkoutService } }) => {
    const { storeId } = getState().root.storeConf;
    const currentStep = getState().checkout.step.label;
    try {
      return await checkoutService.updateCartAttributeByName({ storeId, attributeName, newValue, currentStep }, { signal });
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

type Payload = {
  attributeName: CartAttributeKeys;
  newValue: any;
};
